<template>
    <div class="container">
        <h2 class="rx-title text-left">公司简介</h2>
        <el-row :gutter="20" style="margin-bottom:25px;">
            <el-col :span="14">
                <div class="text-left about-text">
                    <p>{{text1}}</p>
                    <p>{{text2}}</p>
                    <p>{{text3}}</p>
                    <p>{{text4}}</p>
                </div>
            </el-col>
            <el-col :span="10">
                <!-- <div class="renxun-video">
                    <el-button class="play"></el-button>
                </div> -->
                <!-- <video id="myVideo" class="video-js">
                    <source src="@/assets/img/renxun.mp4" type="video/mp4" >
                </video> -->
                <video-player :options="videoOptions"/>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="border-top:1px solid #eee;border-bottom:1px solid #eee;">
            <el-col :span="6"  v-for="client in clients" :key="client.index">
                <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="16" class="text-left">
                        <h1>{{client.title}}</h1>
                        <p>{{client.content}}</p>
                    </el-col>
                    <el-col :span="8" style="margin: 26px 0px;border-right: 1px solid #eee;">
                        <img :src="client.src">
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <h2 class="rx-title text-center">集先进数字化技术为一身的数据服务与管理平台</h2>
        <div class="text-center">
            <img src="@/assets/img/jishu.jpg">
        </div>
    </div>
</template>
<script>
import VideoPlayer from "./VideoPlayer";
export default{
    components: {
        VideoPlayer
    },
    data() {
        return {
            text1: "公司借助早期在行业内的实践和积累,从专业的业内专家的视角,从临床研究行业的痛点出发,在遵循行业规范的前提下,采用新技术新方法,对行业进行数字化赋能,建设用来支撑临床研究项目管理全生命周期的智能化临床研究平台,为药企提供全新的解决方案,旨在降低项目实施成本和管理成本的同时,提高项目的质量并降低项目风险。",
            text2: "仁迅科技自主研发了全栈式的临床研究平台,包括《CTM 临床研究管理系统》,《VMS 可视化管理系统》,《CCM 临床试验协作管理系统》,《MDA 移动数据采集系统》,《SDC 源数据采集系统》,《EDC 电子数据采集系统》,《DCS 文档协作管理系统》,《PVS 药物警戒管理系统》。 平台主要采用云化部署,统一平台运维,每个客户数据安全隔离、独立管理,随时随地享受无感知的平台升级。",
            text3: "仁迅科技的公司理念是：“仁德天下,迅济苍生”,强烈的使命感时刻引领着我们的产品设计理念和核心价值观,采用安全可靠的数字化能力,提高临床研究项目交付质量、加快新药上市是我们始终不断追求的价值所在！",
            text4: "公司立足长三角,在上海、无锡建有研发和技术支持中心,为全国客户提供技术支持服务。",
            clients: [{
                title: '2019',
                content: '成立时间',
                src: require('../../../assets/img/a1.svg')
                }, {
                title: '5',
                content: '办事处',
                src: require('../../../assets/img/a2.svg')
                }, {
                title: '15+',
                content: '自研产品',
                src: require('../../../assets/img/a3.svg')
                }, {
                title: '20+',
                content: '软件著作+专利',
                src: require('../../../assets/img/a4.svg')
            }],
            videoOptions: {
                autoplay: false,//自动播放
                controls: true,//用户可以与之交互的控件
                loop:true,//视频一结束就重新开始
                muted:false,//默认情况下将使所有音频静音
                poster: require('../../../assets/img/rideobg.png'), 
                aspectRatio:"16:9",//显示比率
                fullscreen:{
                    options: {navigationUI: 'hide'}
                },
                sources: [
                    {
                        src: require("@/assets/img/renxun_2021112922823.mp4"),
                        type: "video/mp4"
                    }
                ]
            }
        };
    },
    
}
</script>
<style>
img {
    max-width: 100%;
    height: auto;
}
.about-text p{
    text-indent: 2em;
    color: rgba(0,0,0,.85);
    line-height: 24px;
    font-size: 14px;
    margin-bottom: 10px;
}
.renxun-video{
    background: url(../../../assets/img/rideobg.png) no-repeat scroll center center transparent;
    background-size: 80% auto;
    height: 310px;
    border: 1px solid #eee;
    display: flex;
	justify-content: center; 
	align-items: center; 

}
.play{
    background: url(../../../assets/img/video.png) no-repeat scroll center center transparent;
    background-size: 100% 100%;
    width: 40px;
    height: 40px;
    border: none;
}
.video-js .vjs-big-play-button{
    top: 120px;
    left: 200px;
}
</style>